export const GOOGLE_MAPS_BASE_URL = 'https://www.google.com/maps/dir/';
export const DISABLED_GOOGLE_MAPS_ROUTE_BUTTON_TOOLTIP_MESSAGE =
    'Route start point unavailable. Set unit location or wait for GPS connectivity.';
